import Sidebar from './javascripts/sidebar'

export default Sidebar